import { roundToPlaces } from "../../utils/roundToPlaces.js";
import { Currency } from "../Currency.js";

export function calculateRoundingAdjustment(totalWithTax: number, currency: Currency): number {
	return {
		// Applying always (even though payment is not on delivery), because it's "standard".
		[Currency.CZK]: roundToPlaces(Math.round(totalWithTax) - totalWithTax, 2),
		// You cannot pay on delivery with EUR (see `getSortedPaymentTypesForCustomer`), so it's safe to ignore it here.
		[Currency.EUR]: 0,
	}[currency];
}
